import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { HttpErrorResponse } from "../../../types/responses";
import { assigneePaginationFilterParam } from "../../../types/params";
import { useApiPssFindIncludeAssigneeDetails } from "../datasources/_pss.assignee-details.api.slice";

const usePssFindIncludeAssigneeDetailsRepo = (
  filter?: assigneePaginationFilterParam,
) => {
  const { isSuccess, data, isError, error, isLoading, refetch } =
    useApiPssFindIncludeAssigneeDetails(filter);

  const httpError = error
    ? ((error as FetchBaseQueryError).data as HttpErrorResponse)
    : undefined;

  if (!isLoading) {
  }

  return {
    state: {
      isSuccess,
      assigneeData: data,
      isError,
      error: httpError,
      isLoading,
    },
    action: {
      refetch,
    },
  };
};

export default usePssFindIncludeAssigneeDetailsRepo;
